// import React, { useEffect, useState } from "react";
// import AttachmentsOverview from "./attachments-overview";
// import trelloIFrame from "../shared/trello-client/trello-iframe";
// import useUserContext from "../shared/contexts/user/use-user-context";
// import ConditionalRenderNew from "../modal/utils/conditional-renderer-new";
// // import CreateAccountPrompt from './create-account-prompt.__tsx__NOT_USED';
// import { css } from "@emotion/react";

import AttachmentsOverview from "./attachments-overview";

const Main = () => (
  <main id="attachment-section-root">
    <AttachmentsOverview />
  </main>
);

export default Main;

// const AttachmentSectionMain = () => {
//   const user = useUserContext();

//   return (
//     <ConditionalRenderNew
//       condition1={user.isAuthorizedOnCurrentBoard}
//       renderIf1True={<AttachmentsOverview />}
//       condition2={!!user.idMemberTrello && !user.isAuthorizedOnCurrentBoard}
//       // renderIf2True={<div>You are not authorized to use Bulk Actions on this board. Please, open the Bulk Actions board view (click Bulk Actions board button) for further info.</div>}
//       renderIf2True={
//         <div css={styles.container}>
//           <h2>🔒 This board is not covered by subscription 🔒</h2>
//           <h3>
//             Please, open the <b>Bulk Actions</b> board view (click Bulk Actions
//             board button) for further info. 🔑
//           </h3>
//           <div css={styles.footnote}>
//             If you want to get back to the default Trello Attachment section,
//             disable this one via <em>Bulk Card Attachments</em> card button in
//             the side menu.
//           </div>
//         </div>
//       }
//       renderDefault={null}
//     />
//   );
// };

// export default AttachmentSectionMain;

// const styles = {
//   container: css`
//     margin: auto;
//     text-align: center;
//     padding: 48px 18px;
//   `,
//   footnote: css`
//     padding: 12px;
//     margin-top: 16px;
//     font-size: 12px;
//   `,
// };
